import { Typography } from '@mui/material';
import styled from '@emotion/styled';
import theme from 'src/theme';

interface LabelProps {
  indented?: boolean;
}

const Label = styled(Typography)<LabelProps>(({ indented = true }) => ({
  fontSize: theme.spacing(2.25),
  fontWeight: 600,
  marginInlineStart: indented ? theme.spacing(1) : 0,
  marginBottom: theme.spacing(0.25),
}));

export default Label;
